"use strict";

exports.__esModule = true;
exports.Record = void 0;
const Record = exports.Record = {
  make: (arg = {}) => ({
    ...arg
  }),
  getValue: (record, fieldName) => record[fieldName]
};
//# sourceMappingURL=record.js.map